import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogIn, Loader2 } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";

export default function PartnerLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/partner/login", form);
      navigate("/partner/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <section className="section-dark min-h-screen py-16 px-4" data-testid="partner-login-page">
      <div className="max-w-md mx-auto">
        <p className="gold-kicker mb-2 text-center">PARTNER DASHBOARD</p>
        <h1 className="font-display text-3xl font-black text-slate-100 text-center" data-testid="partner-login-title">Partner Login</h1>
        <p className="text-sm text-slate-400 text-center mt-3 mb-8">Track your referrals, approvals and client activations.</p>
        <form onSubmit={submit} className="card-surface p-6 md:p-8 space-y-4" data-testid="partner-login-form">
          <input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="Registered Email" data-testid="login-email" className="input-dark text-sm w-full" required />
          <input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            placeholder="Password" data-testid="login-password" className="input-dark text-sm w-full" required />
          {error && <p className="text-xs text-red-400" data-testid="login-error">{error}</p>}
          <button type="submit" disabled={busy} data-testid="login-submit-btn" className="btn-gold w-full !py-3.5 text-sm disabled:opacity-60">
            {busy ? <Loader2 size={16} className="animate-spin" /> : <><LogIn size={16} /> LOGIN TO DASHBOARD</>}
          </button>
          <p className="text-[11px] text-slate-500 text-center">Not a partner yet? <Link to="/partner/register" className="text-gold hover:underline" data-testid="goto-register-link">Become a Partner</Link></p>
        </form>
      </div>
    </section>
  );
}
